<template>
  <v-container>
    <v-row>
      <v-col xs="6">
        <v-btn
          v-if="!hideBackBtn"
          text
          @click="$router.push('/model/' + $route.params.model)"
          ><v-icon dark left>mdi-arrow-left</v-icon> Назад</v-btn
        >
        <v-btn v-else text @click="$emit('close')"
          ><v-icon dark left>mdi-close</v-icon> Закрыть</v-btn
        >
        <v-btn
          v-if="deleteBtn"
          text
          @click="$router.push('/model/' + $route.params.model + '/new')"
          ><v-icon dark left>mdi-plus</v-icon> Создать</v-btn
        >
      </v-col>
      <v-col xs="6" class="text-right" v-if="deleteConfirm">
        <div style="display:inline-block;">Удалять?</div>
        <v-btn text @click="$emit('delete')" color="primary">Да</v-btn>
        <v-btn text @click="deleteConfirm = false" color="error">Нет</v-btn>
      </v-col>
      <v-col xs="6" class="text-right" v-else>
        <v-btn text @click="submit" color="primary">Сохранить</v-btn>
        <v-btn text @click="deleteConfirm = true" color="error" v-if="deleteBtn"
          >Удалить</v-btn
        >
      </v-col>
    </v-row>

    <v-row clas="mt-10">
      <v-col
        cols="12"
        md="6"
        xs="12"
        v-for="(field, key) in modelFormatted"
        v-bind:key="key"
      >
        <!-- число -->
        <v-text-field
          v-if="field.type === 'number'"
          :value="field.defaultTo"
          :type="field.type"
          v-model.number="values[key]"
          :label="field.label"
        />

        <!-- date -->
        <div v-else-if="field.type === 'timestamp'">
          <v-text-field
            type="datetime-local"
            :value="getDate(values[key])"
            @input="setDate($event, key)"
          />
        </div>

        <!-- файл -->
        <div v-else-if="field.type === 'file'">
          <v-img
            v-if="values[key] != null"
            :src="values[key].src"
            height="150"
            contain
          />
          <v-file-input
            accept="image/*"
            label="Фотография"
            @change="upload($event, key)"
          ></v-file-input>
          <!-- <input type="hidden" v-model="values[key]" /> -->
        </div>

        <!-- связь -->
        <div v-else-if="'model' in field" class="d-flex align-center">
          <v-autocomplete
            item-text="name"
            item-value="id"
            :items="fieldValues(field, key)"
            :label="field.label"
            v-model="values[key]"
            @click="loadValues(field.model)"
            @keydown="autocomplete($event, key)"
          >
          </v-autocomplete>

          <v-btn text icon color="dark" @click="openDialog(field.model)">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <!-- связь множ.-->
        <div v-else-if="'collection' in field" class="d-flex align-center">
          <v-autocomplete
            item-text="name"
            item-value="id"
            chips
            :items="fieldValues(field, key)"
            :label="field.label"
            v-model="values[key]"
            @click="loadValues(field.collection)"
            @keydown="autocomplete($event, key)"
            multiple
            ref="autocompleteMultiple"
          >
          </v-autocomplete>

          <v-btn text icon color="dark" @click="openDialog(field.model)">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <!-- прочее - просто текст -->
        <v-text-field
          v-else-if="field.type === 'string'"
          :value="field.default"
          :type="field.type"
          v-model="values[key]"
          :label="field.label"
        />
      </v-col>
    </v-row>

    <v-dialog v-model="showDialog" max-width="600px">
      <edit-form
        :model="$store.getters['model' + startCase(activeDialogModel)]"
        :rawValues="{}"
        :clearForm="showDialog"
        @close="showDialog = false"
        @submit="submitDialog"
        hide-back-btn
        v-if="showDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import EditForm from "./Form";

export default {
  name: "EditForm",
  data: function() { 
    return {
      // в values клонируем rawValues, потому что его изменять нельзя
      values: { ...this.rawValues },
      deleteConfirm: false,
      showDialog: false,
      activeDialogModel: null
    };
  },
  components: {
    EditForm
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    rawValues: {
      type: Object,
      default: () => ({})
    },
    deleteBtn: {
      type: Boolean,
      default: false
    },
    hideBackBtn: {
      type: Boolean,
      default: false
    },
    clearForm: {
      type: Boolean,
      default: false
    },
    redraw: {
      type: Number,
      default: 0
    }
  },
  watch: {
    clearForm: function() {
      this.values = {}
    }
  },
  computed: {
    // по этой модельке выводятся поля
    modelFormatted: function() {
      return _.omit(this.model, "events");
    },

    // Это будут данные готовые для передачи в форму
    valuesToSave: function() {
      let res = {};

      //if (this.redraw || this.localRedraw) {
        /* do nothing to make values reactive */
      //}

      for (let key in this.values) {
        // убираем то, чего нет в модельке
        if (key in this.modelFormatted) {
          if (typeof this.values[key] === "object") {
            // Это выглядит крипово, но для массива
            // объектов мы создаём массив айдишников, а просто для массива
            // используем его самого
            if (Array.isArray(this.values[key])) {
              if(typeof this.values[key][0] === "object") {
                res[key] = []
                this.values[key].forEach(item => {
                  res[key].push(item.id)
                })
              } else {
                res[key] = this.values[key];
              }
            } else {
              res[key] = this.values[key].id;
            }
          } else {
            res[key] = this.values[key];
          }
        }
      }

      return res;
    }
  },
  methods: {
    startCase(val) {
      return _.startCase(val);
    },
    submit() {
      this.$emit("submit", _.pickBy(this.valuesToSave, _.identity));
    },
    fieldValues: function(field, key) {
      let currentItems = [];
      let modelName = field.model ? field.model : field.collection;
      let autocompleteItems = this.$store.getters["list" + _.startCase(modelName)] || [];


      if(Array.isArray(this.values[key])) {
        this.values[key].forEach((el)=>{
          if(typeof el === 'object') {
            currentItems.push(el)
          } else {
            currentItems.push(autocompleteItems.find(item => item.id === el))
          }
        })
      } else {
        if(typeof this.values[key] === 'object') {
            currentItems.push(this.values[key])
        } else {
            currentItems.push(autocompleteItems.find(item => item.id === this.values[key]))
        }
      }
      
      currentItems = currentItems.filter(item => typeof item !== undefined);
      return currentItems.concat(autocompleteItems);

      // let oneValue = [];
      // let modelName = field.model ? field.model : field.collection;

      // if(Array.isArray(this.values[key])) {
      //   oneValue = oneValue[0];
      // } else {
      //   oneValue = this.values[key] ? [this.values[key]] : [];
      // }
      
      // let values = this.$store.getters["list" + _.startCase(modelName)] || [];
      
      // return values.concat(oneValue);
      // return this.values[key]
      
    },
    loadValues: function(model, searchString) {
      this.isLoading = true;

      let search = {};

      if (searchString != null) {
        search = {
          where: JSON.stringify({
            name: {
              contains: searchString
            }
          })
        };
      }

      return this.$store.dispatch("find" + _.startCase(model), search).finally(() => {
        this.isLoading = false;
      });
    },
    autocomplete: function(event, key) {
      let search = event.target.value;

      if (!this.isLoading) this.loadValues(key, search);
    },
    upload: function(file, key) {
      let data = new FormData();
      data.append("file", file);

      let config = {
        header: {
          "Content-Type": "multipart/form-data"
        }
      };

      axios
        .post(process.env.VUE_APP_API_URL + "file", data, config)
        .then(resp => {
          this.values[key] = resp.data;
        });
    },
    setDate: function(date, key) {
      let offset = new Date().getTimezoneOffset() * 60 * 1000;
      this.values[key] = new Date(date).getTime() - offset;
    },
    getDate: function(timestamp) {
      if (timestamp) {
        return new Date(timestamp).toISOString().substr(0, 16);
      } else {
        return "";
      }
    },
    openDialog: function(model) {
      this.$store.dispatch("loadModel" + _.startCase(model));
      this.activeDialogModel = model;
      this.showDialog = true;
    },
    submitDialog: function(data) {
      this.$store
        .dispatch("create" + _.startCase(this.activeDialogModel), data)
        .then(resp => {
          this.loadValues(this.activeDialogModel);
          this.values[this.activeDialogModel] = resp.data;
          this.showDialog = false;
        });
    }
  }
}
</script>
